<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4993 4993"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2497" cy="2497" r="2497"/>
     <path class="fil1"
           d="M1746 3114l0 -1760c0,-91 -77,-165 -162,-165 -84,0 -161,74 -161,165l0 1777c-221,78 -379,288 -379,536 0,314 255,569 570,569 314,0 569,-255 569,-569 0,-269 -187,-494 -437,-553z"/>
     <g id="_808038600">
     <path class="fil2"
           d="M2924 2184c0,-130 2,-210 110,-318 81,-81 156,-110 269,-110l0 758c-226,0 -379,-191 -379,-330zm-223 -87c0,170 25,294 138,425 18,20 17,26 34,44l116 88c179,100 392,119 577,26 37,-19 52,-25 86,-51 67,-50 128,-104 170,-179 11,-19 17,-35 26,-52 80,-160 80,-365 0,-525 -19,-37 -25,-52 -50,-86 -63,-83 -37,-56 -103,-111 -18,-15 -17,-15 -38,-31 -248,-184 -612,-142 -813,99 -82,99 -143,212 -143,353z"/>
       <path class="fil2"
             d="M3838 1484c0,35 7,62 26,81 99,102 206,-35 244,-73 47,-48 109,-87 109,-163 0,-59 -48,-107 -117,-107 -63,0 -116,73 -153,109 -36,37 -109,90 -109,153z"/>
       <path class="fil2"
             d="M3838 2787c0,66 196,262 262,262 76,0 117,-45 117,-117 0,-36 -49,-90 -75,-119 -46,-50 -128,-143 -187,-143 -76,0 -117,41 -117,117z"/>
       <path class="fil2"
             d="M2390 1329c0,71 111,153 182,226 128,131 264,-49 161,-151 -26,-25 -43,-43 -68,-68 -73,-73 -85,-114 -178,-114 -54,0 -97,56 -97,107z"/>
       <path class="fil2"
             d="M2390 2932c0,58 46,117 117,117 66,0 262,-196 262,-262 0,-73 -44,-117 -117,-117 -53,0 -262,208 -262,262z"/>
       <path class="fil2"
             d="M3197 989c0,131 -23,274 36,323 40,33 101,33 141,0 59,-49 36,-192 36,-323 0,-129 -213,-129 -213,0z"/>
       <path class="fil2"
             d="M3197 3020c0,206 -39,359 116,359 133,0 97,-206 97,-359 0,-52 -100,-124 -177,-61 -11,9 -36,45 -36,61z"/>
       <path class="fil2"
             d="M4100 2135c0,15 18,60 27,71 49,59 192,36 323,36 128,0 128,-213 0,-213 -131,0 -274,-23 -323,36 -9,11 -27,56 -27,70z"/>
       <path class="fil2"
             d="M2060 2126c0,155 153,116 359,116 16,0 52,-26 61,-36 33,-40 33,-101 0,-141 -49,-59 -192,-36 -323,-36 -49,0 -97,48 -97,97z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'TemperatureLight',
};
</script>

<style scoped>
.fil2 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}

.fil1 {
  fill: #FEFEFE;
  fill-rule: nonzero
}
</style>
